<template>
    <single-news/>
</template>

<script>
import SingleNews from '../components/SingleNews/index'
export default {
	components: {SingleNews  },

}
</script>

<style>

</style>